import { QuizResponseType } from '@app/shared/enums';
import { AclItemApiModel } from '../../AclItemApiModel';

export class QuizWorkflowStepApiModel {
  public Id: number;
  public QuizId: number;
  public Name: string;
  public Acl: Array<AclItemApiModel>;
  public ResponseType: QuizResponseType;
  public NotifyByEmail: boolean;

  public deserialize(data): QuizWorkflowStepApiModel {
    Object.assign(this, data);

    this.Acl = this.Acl.map((x) => new AclItemApiModel().deserialize(x));

    return this;
  }
}
